<script>
import _ from "lodash";
import axios from "axios";
import { ProgressBar } from "uiv";

import RulesDebug from "../../plugins/RulesDebug.vue";
import DatePicker from "../../plugins/DatePicker.vue";

import Habitaciones from "./satotours/Habitaciones";

const cotiInit = {
  error: false,
  loading: false,
  rules: null,
  moneda: null,
  reservar: null,
  politicas: null,
};

export default {
  components: { Habitaciones, ProgressBar, DatePicker, RulesDebug },
  props: {
    url: { type: String, required: true },
    codigo: { type: String, required: true },

    isDev: { type: Boolean, required: false, default: false },
    isPow: { type: Boolean, required: false, default: false },
    isAdmin: { type: Boolean, required: false, default: false },

    terminos: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      maxHabitaciones: 4,
      /* Ficha */
      ficha: null,
      error: false,
      error_texto: "",
      preloader_ficha: true,

      /* Cotizar */
      SGL: 0,
      DBL: 1,
      habitaciones: [],
      fecha: false,
      coti: {
        ...cotiInit,
      },
    };
  },
  created() {
    this.$store.commit("setURL", this.url);
    this.$store.commit("setDev", this.isDev);
    this.$store.commit("setPow", this.isPow);
    this.$store.commit("setAdmin", this.isAdmin);
    this.resetearHabitaciones(this.SGL, this.DBL);

    this.cargar();
  },
  computed: {
    isError(state) {
      return this.error;
    },
    getErrorTexto(state) {
      return this.error_texto;
    },
    isFicha() {
      return this.isError === false && _.hasIn(this.ficha, "codigo");
    },
    fechas() {
      return _.map(this.ficha.salidas, (salida) => {
        return salida.tourstart;
      });
    },
    actionURL() {
      if (this.isReservar) {
        return `${this.url}/sato_tours/reservar`;
      }

      return `${this.url}/circuitos/consultar/SAT/${this.codigo}`;
    },
    fecha_select() {
      if (this.fecha) {
        return _.find(this.ficha.salidas, ["tourstart", this.fecha]);
      }
      return false;
    },
    isCoti() {
      return this.coti.moneda !== null;
    },
    isReservar() {
      return this.coti.reservar;
    },
    rules() {
      if (this.isCoti) {
        return this.coti.rules.rules[this.coti.moneda];
      }
      return false;
    },
    itinerarioUrl() {
      if (!this.ficha) return null;
      if (this.ficha.itinerarioUrl.pdf) {
        return this.ficha.itinerarioUrl.pdf.pdf;
      }
      if (this.ficha.itinerarioUrl.doc) {
        return this.ficha.itinerarioUrl.doc.doc;
      }
      return null;
    },
    reservaFormIsValid() {
      return !this.habitacionConPasajeroSinEdadAsignada;
    },
    habitacionConPasajeroSinEdadAsignada() {
      return this.habitaciones.find(
        (hab) => hab.pasajeros.find((pax) => pax.edad === null)
      );
    },
    errorMensaje() {
      if (this.coti.error) return this.coti.error;
      if (this.habitaciones.length === 0) return 'Debe seleccionar la/s habitaci&oacute;n/es para cotizar.';
      if (this.habitacionConPasajeroSinEdadAsignada) return 'Debe seleccionar las edades para cotizar.';
      return 'Hubo un problema. Recargue la página y vuelva a intentarlo.'
    }
  },
  watch: {
    SGL(newValue) {
      this.resetearHabitaciones(newValue, this.DBL);
    },
    DBL(newValue) {
      this.resetearHabitaciones(this.SGL, newValue);
    },
    fecha() {
      this.cotizar();
    },
    habitaciones: {
      deep: true,
      handler: function () {
        this.cotizar();
      }
    },
  },
  methods: {
    resetearHabitaciones(SGL, DBL) {
      const habitaciones = [];
      for (let i = 1; i <= SGL; i++) {
        habitaciones.push({
          numero: i,
          nombre: "Single",
          base: "SGL",
          pasajeros: [{ numero: 1, tipo: "Adulto", tipoKey: "ADL", edad: null }],
        });
      }
      for (let i = SGL + 1; i <= SGL + DBL; i++) {
        habitaciones.push({
          numero: i,
          nombre: "Doble",
          base: "DBL",
          pasajeros: [
            { numero: 1, tipo: "Adulto", tipoKey: "ADL", edad: null },
            { numero: 2, tipo: "Adulto/Menor", tipoKey: "ADL/CHD", edad: null },
          ],
        });
      }
      this.habitaciones.splice(0, this.habitaciones.length, ...habitaciones);
    },
    cargar() {
      axios
        .get(`${this.url}/sato_tours/ficha/${this.codigo}`)
        .then((response) => {
          if (response.data.error) {
            this.error = true;
            this.error_texto = response.data.error_texto;
          } else {
            this.ficha = response.data.ficha;

            let fechas = response.data.ficha.salidas || [];
            let fecha = _.head(fechas);
            this.fecha = fecha.tourstart;
          }
        })
        .finally(() => {
          this.preloader_ficha = false;
          if (this.error === false) {
            this.cotizar();
          }
        });
    },
    cotizar() {
      if ((this.SGL + this.DBL) > this.maxHabitaciones) {
        this.coti.error = 'No se puede cotizar más de ' + this.maxHabitaciones + ' habitaciones.';
        return;
      }
      this.coti = {
        ...cotiInit,
      };
      const faltaSeleccionarAlgunaEdad = this.habitaciones.find((hab) =>
        hab.pasajeros.find((pax) => pax.edad === null)
      );
      const cotizar =
        (this.SGL > 0 || this.DBL > 0) &&
        this.fecha &&
        !faltaSeleccionarAlgunaEdad &&
        this.preloader_ficha === false;
      if (cotizar) {
        this.coti = {
          ...cotiInit,
          loading: true,
        };
        axios
          .get(`${this.url}/sato_tours/cotizar/${this.codigo}`, {
            params: {
              salida: this.fecha,
              habitaciones: this.habitaciones,
            },
          })
          .then((response) => {
            const data = response.data;
            if (data.error) {
              this.coti.error = data.errorMensaje;
              return;
            }
            this.coti.rules = data.rules;
            this.coti.moneda = data.moneda;
            this.coti.reservar = data.reservar;
            this.coti.politicas = data.politica_cancelacion;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.coti.loading = false;
          });
      }
    },
  },
};
</script>

<template>
  <div id class>
    <div class="container">
      <div class="jumbotron" v-if="preloader_ficha">
        <slot name="preloader_ficha">
          <h1 class="text-center">Cargando...</h1>
          <ProgressBar :value="60" striped active />
        </slot>
      </div>

      <template v-else>
        <template v-if="isError">
          <div class="alert alert-warning" v-html="getErrorTexto"></div>
        </template>

        <div v-if="isFicha">
          <div class="page-header page-header-title animated">
            <slot name="page-header-before"></slot>
            <h3 v-html="ficha.nombre"></h3>
            <div style="margin-bottom: 10px;">
              <share-button
                :url="`${url}/sato_tours/${codigo}?mes=${ficha.mes}`"
                :title="ficha.nombre"
              ></share-button>
              <a
                class="pdf-button btn btn-primary"
                target="_blank"
                :href="itinerarioUrl || `${url}/sato_tours/pdf/${codigo}`"
              >
                <i class="fa fa-download"></i>
                PDF
              </a>
            </div>
            
            <div v-if="ficha.foto" class="row row-0">
              <div class="col-xs-12 col-sm-4">
                <div
                  class="img-bg"
                  :style="{ backgroundImage: `url('${ficha.foto}')` }"
                ></div>
              </div>
            </div>

            <slot name="page-header-after"></slot>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-9">
              <div class="panel panel-default infomacion animated">
                <div class="list-group">
                  <div class="list-group-item">
                    <ul class="list-inline">
                      <li v-if="ficha.inicio">
                        <b>Saliendo:</b>
                        <span v-html="ficha.inicio"></span>
                      </li>
                      <li v-if="ficha.dias">
                        <b>Días:</b>
                        <span v-html="ficha.dias"></span>
                      </li>
                      <li v-if="ficha.noches">
                        <b>Noches:</b>
                        <span v-html="ficha.noches"></span>
                      </li>
                      <li v-if="ficha.ruta">
                        <b>Ruta:</b>
                        <span v-html="ficha.ruta"></span>
                      </li>
                      <li v-if="ficha.categoria">
                        <b><span v-html="'Categor&iacute;a:'"></span></b>
                        <span v-html="ficha.categoria"></span>
                      </li>
                    </ul>
                  </div>

                  <div
                    v-if="ficha.descripcion"
                    class="list-group-item textos_incluye"
                  >
                    <h4
                      class="list-group-item-heading"
                      v-html="'Descripci&oacute;n'"
                    />
                    <div
                      v-html="ficha.descripcion"
                      class="list-group-item-text"
                    ></div>
                  </div>

                  <div
                    v-if="ficha.incluye"
                    class="list-group-item textos_incluye"
                  >
                    <h4
                      class="list-group-item-heading"
                      v-html="'&iquest;Qu&eacute; incluye?'"
                    />
                    <div
                      v-for="item in ficha.incluye"
                      :key="item.descripcion"
                      v-html="item.descripcion"
                      class="list-group-item-text"
                    />
                  </div>

                  <div
                    v-if="ficha.observaciones"
                    class="list-group-item textos_incluye"
                  >
                    <h4 class="list-group-item-heading">Observaciones</h4>
                    <div
                      v-html="ficha.observaciones"
                      class="list-group-item-text"
                    ></div>
                  </div>

                  <div v-if="ficha.map" class="seccion-mapa">
                    <h4 class="list-group-item-heading">Mapa</h4>
                    <img :src="ficha.map" alt="Mapa" />
                  </div>
                </div>
              </div>

              <div class="animated" v-if="ficha.itinerario">
                <div class="page-header">
                  <h3>
                    <i class="fa fa-compass"></i> Itinerario
                    <a
                      class="small pull-right"
                      href="#itinerario"
                      data-toggle="collapse"
                      data-target="#itinerario"
                      aria-expanded="true"
                      aria-controls="itinerario"
                    >
                      <i class="fa fa-caret-down"></i>
                    </a>
                    <div v-if="itinerarioUrl" class="itinerario-descargar">
                      <a :href="itinerarioUrl" target="_blank">
                        <i class="fa fa-download"></i>
                        Descargar
                      </a>
                    </div>
                  </h3>
                </div>

                <div class="collapse in" id="itinerario">
                  <div class="panel panel-default">
                    <div class="list-group">
                      <div
                        v-for="(dia, key) in ficha.itinerario"
                        :key="'ITN-' + key"
                        class="list-group-item row row-0"
                      >
                        <div class="col-xs-12 col-sm-9">
                          <h4 class="list-group-item-heading">
                            <i
                              class="fa"
                              :class="dia.overnight ? 'fa-bed' : 'fa-bus'"
                            ></i>
                            <span v-html="dia.titulo"></span>
                            <small v-if="dia.fecha" v-html="dia.fecha"></small>
                          </h4>

                          <div
                            class="list-group-item-text"
                            v-html="dia.description"
                          ></div>
                        </div>

                        <div
                          v-if="dia.picurl"
                          class="col-xs-12 col-sm-3 img-bg"
                          :style="{
                            backgroundImage: 'url(' + dia.picurl + ')',
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="ficha.hoteles" class="animated hoteles">
                <div class="page-header">
                  <h3>
                    <i class="fa fa-building"></i>Hoteles Previstos
                    <a
                      class="small pull-right"
                      href="#hoteles"
                      data-toggle="collapse"
                      data-target="#hoteles"
                    >
                      <i class="fa fa-caret-down"></i>
                    </a>
                  </h3>
                </div>

                <div class="collapse in" id="hoteles">
                  <div class="panel panel-default">
                    <table class="table">
                      <tbody>
                        <template v-for="hotel in ficha.hoteles">
                          <tr class="active" :key="'HOT-' + hotel.nombre">
                            <th class="ciudad" colspan="2">
                              <i class="fa fa-map-marker small"></i>
                              <span v-html="hotel.nombre" />
                            </th>
                          </tr>
                          <tr>
                            <td :colspan="hotel.picture ? 1 : 2">
                              <h4><span v-html="hotel.nombre" /></h4>
                              <div v-if="hotel.categoria">
                                <span v-html="'Categor&iacute;a:'" />
                                <span v-html="hotel.categoria" />
                              </div>
                              <div v-if="hotel.ciudad">
                                Ciudad: <span v-html="hotel.ciudad" />
                              </div>
                              <div
                                class="description"
                                v-html="hotel.descripcion"
                              />
                            </td>

                            <td class="img" v-if="hotel.picture">
                              <div class="img-thumbnail">
                                <div
                                  class="img"
                                  :style="{
                                    backgroundImage:
                                      'url(' + hotel.picture + ')',
                                  }"
                                ></div>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <form
              v-if="isFicha"
              id="reservar"
              :method="isReservar ? 'POST' : 'GET'"
              :action="actionURL"
              class="col-xs-12 col-sm-6 col-md-3"
            >
              <div class="panel panel-default">
                <div id="calendario">
                  <DatePicker v-model="fecha" :dates="fechas"></DatePicker>
                  <input v-model="fecha" type="hidden" name="salida" />
                </div>
                <div class="list-group">
                  <div class="list-group-item list-group-item-info text-center">
                    <i class="fa fa-calendar"></i> Seleccionar Fecha de Salida
                  </div>
                </div>
              </div>

              <div class="list-group">
                <div class="list-group-item">
                  <div class="input-group input-group-sm">
                    <label class="input-group-addon" for="habitaciones_SGL">
                      <i class="fa fa-bed small"></i> SGL
                    </label>
                    <select
                      class="form-control"
                      name="sgl"
                      v-model.number="SGL"
                      id="habitaciones_SGL"
                    >
                      <option value="0">-</option>
                      <option v-for="numHab in maxHabitaciones" :key="numHab" :value="numHab">{{ numHab }} Habitaciones</option>
                    </select>
                  </div>
                </div>

                <div class="list-group-item">
                  <div class="input-group input-group-sm">
                    <label class="input-group-addon" for="habitaciones_DBL">
                      <i class="fa fa-bed small"></i> DBL
                    </label>
                    <select
                      class="form-control"
                      name="dbl"
                      v-model.number="DBL"
                      id="habitaciones_DBL"
                    >
                      <option value="0">-</option>
                      <option v-for="numHab in maxHabitaciones" :key="numHab" :value="numHab">{{ numHab }} Habitaciones</option>
                    </select>
                  </div>
                </div>
              </div>

              <Habitaciones v-model="habitaciones" />

              <br />

              <div v-if="coti.loading" class="panel panel-default">
                <div class="panel-body text-center">
                  <p>COTIZANDO...</p>
                  <progress-bar :value="60" striped active />
                </div>
              </div>

              <div v-else-if="coti.error || !isCoti" class="panel panel-danger">
                <div class="panel-body text-center" v-html="errorMensaje"/>
              </div>

              <div v-else>
                <template v-if="fecha_select && isReservar">
                  <input
                    type="hidden"
                    name="salida"
                    id="salida"
                    :value="fecha"
                  />
                  <input
                    type="hidden"
                    name="codigo"
                    id="codigo"
                    :value="ficha.codigo"
                  />

                  <input
                    type="hidden"
                    name="tourid"
                    id="tourid"
                    :value="fecha_select.tourid"
                  />
                  <input
                    type="hidden"
                    name="tourcode"
                    id="tourcode"
                    :value="fecha_select.tourcode"
                  />
                  <input
                    type="hidden"
                    name="tourstart"
                    id="tourstart"
                    :value="fecha_select.tourstart"
                  />
                  <input
                    type="hidden"
                    name="tourend"
                    id="tourend"
                    :value="fecha_select.tourend"
                  />
                </template>

                <div class="panel panel-default">
                  <table class="table table-condensed">
                    <thead>
                      <tr class="active">
                        <th>Concepto</th>
                        <th colspan="2" class="text-center">Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, itemKey) in rules.desglose"
                        :key="itemKey"
                        :class="item.class"
                      >
                        <td class="concepto" v-html="item.nombre"></td>
                        <td class="moneda" v-text="item.moneda"></td>
                        <td class="monto" v-text="item.monto"></td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr id="total">
                        <th class="concepto" v-html="terminos.cir_total"></th>
                        <th class="moneda" v-text="rules.moneda"></th>
                        <th class="monto" v-text="rules.total"></th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <template v-if="isPow || isDev">
                  <RulesDebug :src="coti.rules"></RulesDebug>
                  <hr />
                </template>

                <!-- Politica de Cancelacion -->
                <div
                  class="panel panel-warning panel-politicas"
                  v-if="coti.politicas"
                >
                  <div class="panel-heading">
                    <h3
                      class="panel-title"
                      v-html="'Pol&iacute;ticas de Cancelaci&oacute;n'"
                    ></h3>
                  </div>
                  <div class="list-group">
                    <div
                      class="list-group-item list-group-item-warning"
                      id="politicas"
                      v-html="coti.politicas"
                    ></div>
                  </div>
                </div>

                <button
                  type="submit"
                  :disabled="!reservaFormIsValid"
                  class="btn btn-warning btn-block btn-sm"
                  id="btn-reservar"
                  v-if="coti.reservar"
                >
                  <i class="fa fa-shopping-cart"></i>
                  Reservar
                </button>
                <button
                  type="submit"
                  :disabled="!reservaFormIsValid"
                  class="btn btn-info btn-block btn-sm"
                  id="btn-reservar"
                  v-else
                >
                  <i class="fa fa-envelope-open"></i>
                  Consultar
                </button>
              </div>
            </form>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.jumbotron {
  margin: 40px auto;

  .progress {
    margin: 20px 0 0;
  }
}

.img-bg {
  width: 100%;
  height: 100%;
  min-height: 170px;
  background: no-repeat center;
  background-size: cover;
}

.seccion-mapa {
  padding: 15px;
  img {
    margin-top: 10px;
    max-width: 100%;
  }
}
.itinerario-descargar {
  font-size: 14px;
  margin: 10px 0 0 35px;
  a {
    color: #434a54;
    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
}
</style>

